/* 管理端模拟数据（与用户侧字段对齐，按"管理视角"补充平台操作所需字段） */

/* ============ 供应商档案（列表用精简，详情用全量） ============ */
export const vendors = [
  { id: 1, name: '江苏佳诺云电子科技有限公司', code: 'V2026001', type: '供应商', status: '有效', auditStatus: '已通过', contactName: '张经理', contactMobile: '13800138000', projectCount: 3, createTime: '2026-01-15 10:23:00' },
  { id: 2, name: '兰维乐（上海）食品有限公司', code: 'V2026002', type: '服务商', status: '有效', auditStatus: '已通过', contactName: '李经理', contactMobile: '13900139000', projectCount: 2, createTime: '2026-02-08 14:11:00' },
  { id: 3, name: '上海晨光科力普办公用品有限公司', code: 'V2026003', type: '供应商', status: '待审核', auditStatus: '待审核', contactName: '王经理', contactMobile: '13700137000', projectCount: 0, createTime: '2026-07-20 09:45:00' },
  { id: 4, name: '得力集团有限公司', code: 'V2026004', type: '供应商', status: '有效', auditStatus: '已通过', contactName: '赵经理', contactMobile: '13600136000', projectCount: 5, createTime: '2025-11-30 16:50:00' },
  { id: 5, name: '深圳齐心集团股份有限公司', code: 'V2026005', type: '供应商', status: '冻结', auditStatus: '已通过', contactName: '陈经理', contactMobile: '13500135000', projectCount: 1, createTime: '2026-03-12 11:18:00' },
]

/* 供应商全量档案（管理视角）：与用户侧 vendor/detail 字段对齐，并补充平台治理字段 */
export const vendorDetails = {
  1: {
    id: 1, name: '江苏佳诺云电子科技有限公司', shortName: '佳诺云', code: 'V2026001', type: '供应商',
    status: '有效', auditStatus: '已通过', tin: '91320000MA1XXXXXXX', createTime: '2026-01-15 10:23:00',
    logo: '', licenseImage: '', licenseStart: '2024-01-01', licenseEnd: '2034-01-01', licensePermanent: false,
    cooperationCategory: '办公设备、电子耗材、MRO 工业品', brands: '佳诺云、得力',
    legalName: '张三', legalIdNo: '3201XXXXXXXXXX1234', idCardStart: '2018-05-01', idCardEnd: '2038-05-01', idCardPermanent: false,
    defaultContact: { name: '张经理', mobile: '13800138000', email: 'zhang@jianuoyun.com' },
    projectContact: { name: '张经理', mobile: '13800138000', email: 'zhang@jianuoyun.com' },
    orderContact: { name: '李调度', mobile: '13800138001', email: 'order@jianuoyun.com' },
    financeContact: { name: '王财务', mobile: '13800138002', email: 'finance@jianuoyun.com' },
    serviceContact: { name: '赵客服', mobile: '13800138003', email: 'service@jianuoyun.com' },
    logisticsContact: { name: '陈物流', mobile: '13800138004', email: 'wl@jianuoyun.com' },
    invoiceCompanyName: '江苏佳诺云电子科技有限公司', invoiceTaxNo: '91320000MA1XXXXXXX',
    taxpayerType: '0', invoiceRegAddress: '江苏省南京市江宁区秣陵街道XX号', invoiceRegPhone: '025-88889999',
    invoiceBankName: '工商银行南京江宁支行', invoiceBankAccount: '6222000000000001', invoiceScanFile: '',
    warehouseArea: 5200, transportVehicles: 12, customerService: 30, expressLogistics: '顺丰、京东、中通',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '工商银行南京江宁支行', bankSubBranchName: '江宁科学园支行', bankCode: '102301000000',
    bankAccountName: '江苏佳诺云电子科技有限公司', bankAccount: '6222000000000001',
    returnFullAddress: '江苏省南京市江宁区秣陵街道XX号仓库A栋', returnContacts: '陈物流', returnContactsMobile: '13800138004',
    shipFullAddress: '江苏省南京市江宁区秣陵街道XX号仓库B栋', shipContacts: '陈物流', shipContactsMobile: '13800138004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  2: {
    id: 2, name: '兰维乐（上海）食品有限公司', shortName: '兰维乐', code: 'V2026002', type: '服务商',
    status: '有效', auditStatus: '已通过', tin: '91310000MA1YYYYYYY', createTime: '2026-02-08 14:11:00',
    logo: '', licenseImage: '', licenseStart: '2023-06-01', licenseEnd: '2033-06-01', licensePermanent: false,
    cooperationCategory: '食品饮料、滋补养生', brands: '兰维乐',
    legalName: '李四', legalIdNo: '3101XXXXXXXXXX5678', idCardStart: '2019-03-01', idCardEnd: '2039-03-01', idCardPermanent: false,
    defaultContact: { name: '李经理', mobile: '13900139000', email: 'li@lanweile.com' },
    projectContact: { name: '李经理', mobile: '13900139000', email: 'li@lanweile.com' },
    orderContact: { name: '周调度', mobile: '13900139001', email: 'order@lanweile.com' },
    financeContact: { name: '吴财务', mobile: '13900139002', email: 'finance@lanweile.com' },
    serviceContact: { name: '郑客服', mobile: '13900139003', email: 'service@lanweile.com' },
    logisticsContact: { name: '孙物流', mobile: '13900139004', email: 'wl@lanweile.com' },
    invoiceCompanyName: '兰维乐（上海）食品有限公司', invoiceTaxNo: '91310000MA1YYYYYYY',
    taxpayerType: '0', invoiceRegAddress: '上海市浦东新区张江高科技园区XX路XX号', invoiceRegPhone: '021-66667777',
    invoiceBankName: '招商银行上海张江支行', invoiceBankAccount: '6225888800000002', invoiceScanFile: '',
    warehouseArea: 8600, transportVehicles: 20, customerService: 45, expressLogistics: '顺丰冷链、京东冷链',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '招商银行上海张江支行', bankSubBranchName: '张江高科支行', bankCode: '308290000000',
    bankAccountName: '兰维乐（上海）食品有限公司', bankAccount: '6225888800000002',
    returnFullAddress: '上海市浦东新区张江高科技园区XX路XX号冷库', returnContacts: '孙物流', returnContactsMobile: '13900139004',
    shipFullAddress: '上海市浦东新区张江高科技园区XX路XX号仓库', shipContacts: '孙物流', shipContactsMobile: '13900139004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  3: {
    id: 3, name: '上海晨光科力普办公用品有限公司', shortName: '科力普', code: 'V2026003', type: '供应商',
    status: '待审核', auditStatus: '待审核', tin: '91310000MA3ZZZZZZZ', createTime: '2026-07-20 09:45:00',
    logo: '', licenseImage: '', licenseStart: '2025-01-01', licenseEnd: '2035-01-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公日用', brands: '晨光、科力普',
    legalName: '王五', legalIdNo: '3101XXXXXXXXXX9999', idCardStart: '2020-01-01', idCardEnd: '2040-01-01', idCardPermanent: false,
    defaultContact: { name: '王经理', mobile: '13700137000', email: 'wang@colipu.com' },
    projectContact: { name: '王经理', mobile: '13700137000', email: 'wang@colipu.com' },
    orderContact: { name: '冯调度', mobile: '13700137001', email: 'order@colipu.com' },
    financeContact: { name: '蒋财务', mobile: '13700137002', email: 'finance@colipu.com' },
    serviceContact: { name: '韩客服', mobile: '13700137003', email: 'service@colipu.com' },
    logisticsContact: { name: '杨物流', mobile: '13700137004', email: 'wl@colipu.com' },
    invoiceCompanyName: '上海晨光科力普办公用品有限公司', invoiceTaxNo: '91310000MA3ZZZZZZZ',
    taxpayerType: '0', invoiceRegAddress: '上海市奉贤区光明A3工业园区XX号', invoiceRegPhone: '021-55556666',
    invoiceBankName: '建设银行上海奉贤支行', invoiceBankAccount: '6227000000000003', invoiceScanFile: '',
    warehouseArea: 12000, transportVehicles: 35, customerService: 80, expressLogistics: '顺丰、德邦、安能',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '建设银行上海奉贤支行', bankSubBranchName: '奉贤工业园支行', bankCode: '105290000000',
    bankAccountName: '上海晨光科力普办公用品有限公司', bankAccount: '6227000000000003',
    returnFullAddress: '上海市奉贤区光明A3工业园区XX号退货仓', returnContacts: '杨物流', returnContactsMobile: '13700137004',
    shipFullAddress: '上海市奉贤区光明A3工业园区XX号发货仓', shipContacts: '杨物流', shipContactsMobile: '13700137004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  4: {
    id: 4, name: '得力集团有限公司', shortName: '得力', code: 'V2026004', type: '供应商',
    status: '有效', auditStatus: '已通过', tin: '91330200MA4AAAAAAA', createTime: '2025-11-30 16:50:00',
    logo: '', licenseImage: '', licenseStart: '2022-01-01', licenseEnd: '2032-01-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公设备、MRO', brands: '得力、纽赛',
    legalName: '赵六', legalIdNo: '3302XXXXXXXXXX1111', idCardStart: '2017-01-01', idCardEnd: '2037-01-01', idCardPermanent: false,
    defaultContact: { name: '赵经理', mobile: '13600136000', email: 'zhao@deli.com' },
    projectContact: { name: '赵经理', mobile: '13600136000', email: 'zhao@deli.com' },
    orderContact: { name: '钱调度', mobile: '13600136001', email: 'order@deli.com' },
    financeContact: { name: '孙财务', mobile: '13600136002', email: 'finance@deli.com' },
    serviceContact: { name: '李客服', mobile: '13600136003', email: 'service@deli.com' },
    logisticsContact: { name: '周物流', mobile: '13600136004', email: 'wl@deli.com' },
    invoiceCompanyName: '得力集团有限公司', invoiceTaxNo: '91330200MA4AAAAAAA',
    taxpayerType: '0', invoiceRegAddress: '浙江省宁波市宁海县得力工业园', invoiceRegPhone: '0574-65558888',
    invoiceBankName: '中国银行宁海支行', invoiceBankAccount: '6226000000000004', invoiceScanFile: '',
    warehouseArea: 30000, transportVehicles: 60, customerService: 150, expressLogistics: '德邦、顺丰、京东',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '中国银行宁海支行', bankSubBranchName: '宁海科技支行', bankCode: '104332000000',
    bankAccountName: '得力集团有限公司', bankAccount: '6226000000000004',
    returnFullAddress: '浙江省宁波市宁海县得力工业园退货中心', returnContacts: '周物流', returnContactsMobile: '13600136004',
    shipFullAddress: '浙江省宁波市宁海县得力工业园发货中心', shipContacts: '周物流', shipContactsMobile: '13600136004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '', attestFile: '',
  },
  5: {
    id: 5, name: '深圳齐心集团股份有限公司', shortName: '齐心', code: 'V2026005', type: '供应商',
    status: '冻结', auditStatus: '已通过', tin: '91440300MA5BBBBBBB', createTime: '2026-03-12 11:18:00',
    logo: '', licenseImage: '', licenseStart: '2023-03-01', licenseEnd: '2033-03-01', licensePermanent: false,
    cooperationCategory: '办公文具、办公日用', brands: '齐心、Comix',
    legalName: '陈七', legalIdNo: '4403XXXXXXXXXX2222', idCardStart: '2019-06-01', idCardEnd: '2039-06-01', idCardPermanent: false,
    defaultContact: { name: '陈经理', mobile: '13500135000', email: 'chen@comix.com' },
    projectContact: { name: '陈经理', mobile: '13500135000', email: 'chen@comix.com' },
    orderContact: { name: '卫调度', mobile: '13500135001', email: 'order@comix.com' },
    financeContact: { name: '蒋财务', mobile: '13500135002', email: 'finance@comix.com' },
    serviceContact: { name: '沈客服', mobile: '13500135003', email: 'service@comix.com' },
    logisticsContact: { name: '韩物流', mobile: '13500135004', email: 'wl@comix.com' },
    invoiceCompanyName: '深圳齐心集团股份有限公司', invoiceTaxNo: '91440300MA5BBBBBBB',
    taxpayerType: '0', invoiceRegAddress: '广东省深圳市坪山区齐心科技园', invoiceRegPhone: '0755-89999999',
    invoiceBankName: '平安银行深圳坪山支行', invoiceBankAccount: '6229800000000005', invoiceScanFile: '',
    warehouseArea: 18000, transportVehicles: 40, customerService: 90, expressLogistics: '顺丰、中通、圆通',
    warehouseCertUrl: '', logisticsCertUrl: '', accountLicenseUrl: '', taxpayerQualificationUrl: '',
    bankName: '平安银行深圳坪山支行', bankSubBranchName: '坪山支行', bankCode: '307584000000',
    bankAccountName: '深圳齐心集团股份有限公司', bankAccount: '6229800000000005',
    returnFullAddress: '广东省深圳市坪山区齐心科技园退货仓', returnContacts: '韩物流', returnContactsMobile: '13500135004',
    shipFullAddress: '广东省深圳市坪山区齐心科技园发货仓', shipContacts: '韩物流', shipContactsMobile: '13500135004',
    lastTaxPayCertificate: '', signQualificationsSummary: '',
    updateReason: '因履约异常被平台冻结', attestFile: '',
  },
}

/* 供应商关联订单（管理视角：监控全量） */
export const vendorOrders = {
  1: [
    { orderNo: 'PO202601150001', purchaser: '浦东发展银行', itemCount: 12, totalAmount: '12580.00', status: '已妥投', sla: '正常', orderTime: '2026-01-15 09:00:00' },
    { orderNo: 'PO202603100012', purchaser: '兴业银行集采', itemCount: 8, totalAmount: '8600.00', status: '已发货', sla: '正常', orderTime: '2026-03-10 11:20:00' },
  ],
  5: [
    { orderNo: 'PO202606200033', purchaser: '浦东发展银行', itemCount: 5, totalAmount: '4300.00', status: '待发货', sla: '超期', orderTime: '2026-06-20 09:00:00' },
  ],
}

/* 供应商关联对账单（管理视角） */
export const vendorBills = {
  1: [
    { billNo: 'B202601150001', billPeriod: '2026-01', orderCount: 12, totalAmount: '12580.00', status: '已确认', createTime: '2026-02-01 09:00:00' },
  ],
  5: [
    { billNo: 'B202606200033', billPeriod: '2026-06', orderCount: 5, totalAmount: '4300.00', status: '待确认', createTime: '2026-07-01 09:00:00' },
  ],
}

/* ============ 供应商信息变更审批（结构化前后对比） ============ */
export const vendorChanges = [
  {
    id: 101, vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司', applyTime: '2026-07-22 10:00:00', status: '待审核',
    fields: [
      { label: '法人姓名', before: '张三', after: '张四' },
      { label: '开户银行', before: '工商银行', after: '建设银行' },
    ],
  },
  {
    id: 102, vendorId: 2, vendorName: '兰维乐（上海）食品有限公司', applyTime: '2026-07-23 14:30:00', status: '待审核',
    fields: [
      { label: '联系人姓名', before: '李经理', after: '李总' },
      { label: '退货地址', before: '上海浦东', after: '上海徐汇' },
    ],
  },
  {
    id: 103, vendorId: 5, vendorName: '深圳齐心集团股份有限公司', applyTime: '2026-07-20 09:15:00', status: '已通过',
    fields: [
      { label: '银行账户', before: '6222000000000001', after: '6222000000000002' },
    ],
  },
]

/* ============ 商品审核（全量字段，与用户侧 serviceItemList 对齐） ============ */
export const products = [
  {
    id: 1, skuId: '18607831', name: '兰维乐 矿泉水 360ml*24瓶', itemId: '18607831',
    image: 'https://cdnprod.ea380buy.com/images/40e7784d-0437-408d-aa9c-1f36c0353f79.jpg',
    category: '水', categoryPath: '食品饮料 / 水 / 饮用水', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '360ml*24瓶/箱', unit: '箱', price: '59.90', cost: '42.00', stock: 1200,
    auditStatus: '待审核', submitTime: '2026-07-24 10:00:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 2, skuId: '18610109', name: '兰维乐 UMF10+ 250g/瓶 蜂蜜', itemId: '18610109', image: '',
    category: '滋补养生', categoryPath: '食品饮料 / 滋补养生 / 蜂蜜', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '250g/瓶', unit: '瓶', price: '399.00', cost: '280.00', stock: 360,
    auditStatus: '待审核', submitTime: '2026-07-24 11:30:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 3, skuId: '18610115', name: '兰维乐 矿泉水 600ML*12瓶', itemId: '18610115', image: '',
    category: '水', categoryPath: '食品饮料 / 水 / 饮用水', brand: '兰维乐',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', itemType: '普通商品',
    spec: '600ML*12瓶/箱', unit: '箱', price: '35.90', cost: '25.00', stock: 2400,
    auditStatus: '已通过', submitTime: '2026-07-23 09:00:00', submitter: '李经理', rejectReason: '',
  },
  {
    id: 4, skuId: '20010088', name: '得力 A4 复印纸 70g 500张/包', itemId: '20010088', image: '',
    category: '办公文具', categoryPath: '办公文具 / 办公用纸 / 复印纸', brand: '得力',
    vendorName: '得力集团有限公司', projectName: '兴业银行集采', itemType: '普通商品',
    spec: '70g 500张/包', unit: '包', price: '25.00', cost: '18.50', stock: 8000,
    auditStatus: '已拒绝', submitTime: '2026-07-22 15:00:00', submitter: '赵经理', rejectReason: '商品类目与品牌授权不符，请重新选择类目后再提交。',
  },
]

/* 商品审核进度（审核工作台节点） */
export const productAuditProcess = {
  1: [
    { node: '供应商提交', time: '2026-07-24 10:00:00', operator: '李经理', status: 'done', desc: '商品信息已提交' },
    { node: '平台初审', time: '2026-07-24 14:00:00', operator: '品类运营-小王', status: 'done', desc: '资料完整，进入终审' },
    { node: '平台终审', time: '', operator: '', status: 'process', desc: '等待终审结果' },
  ],
  4: [
    { node: '供应商提交', time: '2026-07-22 15:00:00', operator: '赵经理', status: 'done', desc: '商品信息已提交' },
    { node: '平台初审', time: '2026-07-22 17:00:00', operator: '品类运营-小王', status: 'done', desc: '发现类目不符' },
    { node: '平台终审', time: '2026-07-23 09:30:00', operator: '品类运营-小王', status: 'reject', desc: '已驳回：商品类目与品牌授权不符' },
  ],
}

/* ============ 采购订单监控（全量，含商品行） ============ */
export const orders = [
  {
    id: 1, orderNo: 'PO202607240001', vendorName: '江苏佳诺云电子科技有限公司', purchaser: '浦东发展银行',
    itemCount: 12, totalAmount: '12580.00', status: '待发货', sla: '正常', orderTime: '2026-07-24 09:00:00',
    receiveInfo: '上海市浦东新区浦东南路XX号 张主任 13800001111',
    lines: [
      { skuId: '19001234', itemName: '佳诺云 无线键鼠套装 KW-200', spec: '黑色/套', price: '199.00', cost: '140.00', quantity: 12, taxRate: '13%' },
    ],
  },
  {
    id: 2, orderNo: 'PO202607240002', vendorName: '兰维乐（上海）食品有限公司', purchaser: '兴业银行集采',
    itemCount: 5, totalAmount: '3890.50', status: '已发货', sla: '正常', orderTime: '2026-07-23 14:00:00',
    receiveInfo: '上海市徐汇区虹桥路XX号 李主管 13800002222',
    logistics: '顺丰 SF1234567890 已揽收',
    lines: [
      { skuId: '18607831', itemName: '兰维乐 矿泉水 360ml*24瓶', spec: '360ml*24瓶/箱', price: '59.90', cost: '42.00', quantity: 50, taxRate: '13%' },
    ],
  },
  {
    id: 3, orderNo: 'PO202607220003', vendorName: '得力集团有限公司', purchaser: '浦东发展银行',
    itemCount: 30, totalAmount: '25600.00', status: '待发货', sla: '超期', orderTime: '2026-07-22 10:00:00',
    receiveInfo: '上海市浦东新区浦东南路XX号 王经理 13800003333',
    lines: [
      { skuId: '20010088', itemName: '得力 A4 复印纸 70g 500张/包', spec: '70g 500张/包', price: '25.00', cost: '18.50', quantity: 800, taxRate: '13%' },
    ],
  },
]

/* ============ 对账单管理（全量字段，与用户侧 supplierBillSup 对齐） ============ */
export const bills = [
  {
    id: 1, billNo: 'B202607240001', vendorName: '江苏佳诺云电子科技有限公司', billPeriod: '2026-07', orderCount: 12,
    totalAmount: '12580.00', status: '待确认', createTime: '2026-07-25 09:00:00',
    invoiceTitle: '江苏佳诺云电子科技有限公司', billType: '联采', project: '浦东发展银行', selfBuilt: '否',
    hasInvoice: '是', invoiceStatus: '发票待审核', submitDate: '2026-07-25', remark: '',
  },
  {
    id: 2, billNo: 'B202607240002', vendorName: '兰维乐（上海）食品有限公司', billPeriod: '2026-07', orderCount: 5,
    totalAmount: '3890.50', status: '已确认', createTime: '2026-07-25 08:00:00',
    invoiceTitle: '兰维乐（上海）食品有限公司', billType: '购销', project: '兴业银行集采', selfBuilt: '否',
    hasInvoice: '是', invoiceStatus: '发票审核通过', submitDate: '2026-07-25', remark: '含冷链运费',
  },
  {
    id: 3, billNo: 'B202607240003', vendorName: '得力集团有限公司', billPeriod: '2026-07', orderCount: 30,
    totalAmount: '25600.00', status: '处理中', createTime: '2026-07-24 16:00:00',
    invoiceTitle: '得力集团有限公司', billType: '联采', project: '浦东发展银行', selfBuilt: '否',
    hasInvoice: '否', invoiceStatus: '发票待审核', submitDate: '2026-07-24', remark: '',
  },
]

/* ============ 报备订单（管理视角：全平台报备单审核台，含供应商名与审核状态） ============ */
export const reportOrders = [
  {
    id: 1, reportNo: 'R202607240001', orderNo: 'PO202607200001', customerOrderNo: 'C202607200001',
    reportType: '单号报备', vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采',
    purchaseUnitName: '兴业银行股份有限公司', reportStatus: '待审核', auditStatus: '待审核',
    expiringSoon: '1', regionText: '安徽省 / 合肥市', skuId: '19001234', createTime: '2026-07-24 09:10:00',
    detail: { reportType: '单号报备', projectName: '兴业银行集采', purchaseUnitName: '兴业银行股份有限公司', regionText: '安徽省 / 合肥市', skuId: '19001234', remark: '客户预约单需平台报备关联' },
  },
  {
    id: 2, reportNo: 'R202607230002', orderNo: 'PO202607180002', customerOrderNo: 'C202607180002',
    reportType: '商品明细报备', vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行',
    purchaseUnitName: '上海浦东发展银行总行', reportStatus: '已通过', auditStatus: '已通过',
    expiringSoon: '0', regionText: '上海市 / 浦东新区', skuId: '18607831', createTime: '2026-07-23 11:00:00',
    detail: { reportType: '商品明细报备', projectName: '浦东发展银行', purchaseUnitName: '上海浦东发展银行总行', regionText: '上海市 / 浦东新区', skuId: '18607831', remark: '商品明细报备已核对' },
  },
  {
    id: 3, reportNo: 'R202607220003', orderNo: 'PO202607150003', customerOrderNo: 'C202607150003',
    reportType: '单号报备', vendorName: '得力集团有限公司', projectName: '兴业银行集采',
    purchaseUnitName: '兴业银行股份有限公司', reportStatus: '已拒绝', auditStatus: '已拒绝',
    expiringSoon: '0', regionText: '浙江省 / 宁波市', skuId: '20010088', createTime: '2026-07-22 14:30:00',
    detail: { reportType: '单号报备', projectName: '兴业银行集采', purchaseUnitName: '兴业银行股份有限公司', regionText: '浙江省 / 宁波市', skuId: '20010088', remark: '报备单号与采购订单号不匹配' },
    rejectReason: '报备单号与采购订单号不匹配，请核对后重新提交',
  },
]

/* ============ 反采申请单（管理视角：全平台反采申请审核台） ============ */
export const reverseApps = [
  {
    id: 1, applicationNo: 'F202607240001', purchaseOrderNo: 'PO202607200010', vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '兴业银行集采', skuId: '19001234', skuName: '佳诺云 无线键鼠套装 KW-200', skuCode: 'LN-19001234',
    skuImage: '', applyQty: 20, confirmQty: '', reversePrice: '180.00', goodsPayable: '3600.00', totalAmount: '3600.00',
    status: '待审核', rejectReason: '', createTime: '2026-07-24 10:20:00',
    detail: { applicationNo: 'F202607240001', purchaseOrderNo: 'PO202607200010', projectName: '兴业银行集采', skuName: '佳诺云 无线键鼠套装 KW-200', applyQty: 20, reversePrice: '180.00', remark: '客户临时追加，需平台反向采购' },
  },
  {
    id: 2, applicationNo: 'F202607230002', purchaseOrderNo: 'PO202607180020', vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', skuId: '18607831', skuName: '兰维乐 矿泉水 360ml*24瓶', skuCode: 'LN-18607831',
    skuImage: '', applyQty: 50, confirmQty: 50, reversePrice: '45.00', goodsPayable: '2250.00', totalAmount: '2250.00',
    status: '已通过', rejectReason: '', createTime: '2026-07-23 16:40:00',
    detail: { applicationNo: 'F202607230002', purchaseOrderNo: 'PO202607180020', projectName: '浦东发展银行', skuName: '兰维乐 矿泉水 360ml*24瓶', applyQty: 50, confirmQty: 50, reversePrice: '45.00', remark: '已确认采购数量' },
  },
  {
    id: 3, applicationNo: 'F202607220003', purchaseOrderNo: 'PO202607150030', vendorName: '得力集团有限公司',
    projectName: '兴业银行集采', skuId: '20010088', skuName: '得力 A4 复印纸 70g 500张/包', skuCode: 'LN-20010088',
    skuImage: '', applyQty: 100, confirmQty: '', reversePrice: '22.00', goodsPayable: '2200.00', totalAmount: '2200.00',
    status: '已拒绝', rejectReason: '反采单价高于市场集采价，请按集采协议价重新提交', createTime: '2026-07-22 09:30:00',
    detail: { applicationNo: 'F202607220003', purchaseOrderNo: 'PO202607150030', projectName: '兴业银行集采', skuName: '得力 A4 复印纸 70g 500张/包', applyQty: 100, reversePrice: '22.00', remark: '供应商发起反采' },
  },
]

/* ============ 发货单管理（管理视角：全平台发货单与物流监控） ============ */
export const shipOrders = [
  {
    id: 1, shipId: 'S202607240001', purchaseOrderNo: 'PO202607200001', customerOrderNo: 'C202607200001',
    vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采', warehouse: '南京江宁仓',
    logisticsCompany: '顺丰速运', trackingNo: 'SF1234567890', status: '已发货', deliveredStatus: '未妥投',
    rejectStatus: '无', deliverableTime: '2026-07-26 18:00:00', deliveredTime: '',
    isUnionOrder: '否', receiver: '张主任', receiverMobile: '13800001111', receiverAddress: '上海市浦东新区浦东南路XX号',
    createTime: '2026-07-24 09:00:00', logistics: '顺丰 SF1234567890 已揽收，运输中',
  },
  {
    id: 2, shipId: 'S202607230002', purchaseOrderNo: 'PO202607180002', customerOrderNo: 'C202607180002',
    vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', warehouse: '上海张江冷库',
    logisticsCompany: '京东冷链', trackingNo: 'JD0099887766', status: '已妥投', deliveredStatus: '已妥投',
    rejectStatus: '无', deliverableTime: '2026-07-24 12:00:00', deliveredTime: '2026-07-24 11:30:00',
    isUnionOrder: '否', receiver: '李主管', receiverMobile: '13800002222', receiverAddress: '上海市徐汇区虹桥路XX号',
    createTime: '2026-07-23 10:00:00', logistics: '京东冷链 JD0099887766 已签收',
  },
  {
    id: 3, shipId: 'S202607220003', purchaseOrderNo: 'PO202607150003', customerOrderNo: 'C202607150003',
    vendorName: '得力集团有限公司', projectName: '兴业银行集采', warehouse: '宁波宁海仓',
    logisticsCompany: '德邦快递', trackingNo: 'DB5566778899', status: '已拒收', deliveredStatus: '未妥投',
    rejectStatus: '已拒收', deliverableTime: '2026-07-23 18:00:00', deliveredTime: '',
    isUnionOrder: '是', receiver: '王经理', receiverMobile: '13800003333', receiverAddress: '上海市浦东新区浦东南路XX号',
    createTime: '2026-07-22 08:00:00', logistics: '德邦 DB5566778899 客户拒收退回',
  },
]

/* ============ 操作日志（全局审计追踪，各模块审核/治理动作均追加写入 store.logs） ============ */
export const seedLogs = [
  { id: 1, time: '2026-07-24 14:00:00', module: '商品', action: '商品初审通过', target: '兰维乐 矿泉水 360ml*24瓶', operator: '品类运营-小王', detail: '资料完整，进入终审' },
  { id: 2, time: '2026-07-23 09:30:00', module: '商品', action: '商品驳回', target: '得力 A4 复印纸 70g 500张/包', operator: '品类运营-小王', detail: '类目与品牌授权不符，已通知供应商' },
  { id: 3, time: '2026-07-23 09:00:00', module: '商品', action: '商品审核通过并上架', target: '兰维乐 矿泉水 600ML*12瓶', operator: '品类运营-小王', detail: '已上架至商品中心' },
  { id: 4, time: '2026-07-22 09:15:00', module: '供应商', action: '信息变更通过', target: '深圳齐心集团股份有限公司', operator: '平台管理员', detail: '银行账户变更 6222...0001 → 0002' },
  { id: 5, time: '2026-07-20 09:45:00', module: '供应商', action: '入驻申请提交', target: '上海晨光科力普办公用品有限公司', operator: '王经理', detail: '供应商提交入驻申请，待平台审核' },
  { id: 6, time: '2026-07-25 09:00:00', module: '财务', action: '生成对账单', target: 'B202607240001', operator: '系统', detail: '江苏佳诺云电子科技有限公司 2026-07 账期' },
  { id: 7, time: '2026-07-24 10:00:00', module: '订单', action: '订单创建', target: 'PO202607240001', operator: '浦东发展银行', detail: '采购订单创建，待供应商发货' },
]

/* ============ 资质/授权审核（管理视角，与用户侧 vendor/qualification 对齐） ============ */
export const qualifications = [
  { id: 1, vendorId: 1001, vendorName: '江苏佳诺云电子科技有限公司', certType: '品牌授权', level: '省级代理', type: '授权', category: '数码电器', brandName: '联想', categoryName: '笔记本电脑', auditStatus: '待审核', projectName: '兴业银行集采', itemId: 'I2001', startDate: '2026-01-01', endDate: '2026-12-31', submitTime: '2026-07-20 09:00:00', updateTime: '2026-07-20 09:00:00', remark: '' },
  { id: 2, vendorId: 1002, vendorName: '兰维乐（上海）食品有限公司', certType: '食品经营许可证', level: '-', type: '资质', category: '食品生鲜', brandName: '兰维乐', categoryName: '乳制品', auditStatus: '已通过', projectName: '浦东发展银行', itemId: 'I2002', startDate: '2026-03-01', endDate: '2027-02-28', submitTime: '2026-06-10 14:00:00', updateTime: '2026-06-12 10:00:00', remark: '资料齐全' },
  { id: 3, vendorId: 1003, vendorName: '得力集团有限公司', certType: '品牌授权', level: '全国总代', type: '授权', category: '办公文具', brandName: '得力', categoryName: '办公文具', auditStatus: '待审核', projectName: '兴业银行集采', itemId: 'I2003', startDate: '2026-05-01', endDate: '2027-04-30', submitTime: '2026-07-22 16:30:00', updateTime: '2026-07-22 16:30:00', remark: '' },
  { id: 4, vendorId: 1004, vendorName: '深圳齐心集团股份有限公司', certType: 'ISO9001', level: '-', type: '资质', category: '办公文具', brandName: '齐心', categoryName: '办公耗材', auditStatus: '已驳回', projectName: '浦东发展银行', itemId: 'I2004', startDate: '2026-02-01', endDate: '2027-01-31', submitTime: '2026-06-20 11:00:00', updateTime: '2026-06-21 09:00:00', remark: '证书扫描件模糊，请重新上传' },
  { id: 5, vendorId: 1005, vendorName: '上海晨光科力普办公用品有限公司', certType: '品牌授权', level: '区域代理', type: '授权', category: '办公文具', brandName: '晨光', categoryName: '书写工具', auditStatus: '已过期', projectName: '联家', itemId: 'I2005', startDate: '2025-01-01', endDate: '2025-12-31', submitTime: '2025-11-01 10:00:00', updateTime: '2025-12-31 00:00:00', remark: '授权已过期，需续签' },
]

/* ============ 合同模板库（管理端起草合同时引用） ============ */
export const contractTemplates = [
  {
    id: 1, name: '供应商合作框架协议（年度）', category: '框架协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '按实际订单月度结算', enabled: true, updatedAt: '2026-07-10 10:00:00',
    variables: ['供应商名称', '合作项目', '有效期', '账期', '结算日'],
    content: '甲方（平台）：安徽亿佳供应链集团有限公司\n乙方（供应商）：{供应商名称}\n一、合作内容：乙方作为甲方“{合作项目}”项目的指定供应商，按甲方订单供货。\n二、合同有效期：{有效期}。\n三、结算与账期：双方按月结算，账期为 {账期} 天，每月 {结算日} 日为对账结算日。\n四、电子签署：本合同通过第三方电子签名平台（持牌CA+意愿认证+区块链存证）在线签署，与纸质盖章件具有同等法律效力。\n五、保密与合规：双方对在合作中知悉的对方商业秘密负有保密义务。',
  },
  {
    id: 2, name: '单笔采购合同', category: '单笔合同', signType: 1, validityMonths: 6, paymentDays: 60, settleDay: 20,
    amountDesc: '按单笔订单金额结算', enabled: true, updatedAt: '2026-07-12 14:20:00',
    variables: ['供应商名称', '采购方', '合同金额', '有效期', '账期'],
    content: '甲方（采购方）：{采购方}\n乙方（供应商）：{供应商名称}\n一、采购标的：详见附件订单清单，合同金额（含税）{合同金额}。\n二、合同有效期：{有效期}。\n三、结算与账期：账期 {账期} 天，到期货款凭合规发票支付。\n四、电子签署：本合同经第三方电子签名平台签署后生效，具备法律效力。',
  },
  {
    id: 3, name: '补充协议（框架协议变更）', category: '补充协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '随主协议结算', enabled: true, updatedAt: '2026-07-15 09:30:00',
    variables: ['供应商名称', '主协议编号', '变更内容', '有效期'],
    content: '本协议为《供应商合作框架协议》（主协议编号：{主协议编号}）之补充协议，签约双方：{供应商名称} 与 安徽亿佳供应链集团有限公司。\n一、变更内容：{变更内容}。\n二、有效期：{有效期}。\n三、本协议与主协议具有同等法律效力，冲突部分以本协议为准。',
  },
  {
    id: 4, name: '保密与竞业限制协议', category: '专项协议', signType: 2, validityMonths: 24, paymentDays: 0, settleDay: 25,
    amountDesc: '无金额', enabled: true, updatedAt: '2026-07-08 16:00:00',
    variables: ['供应商名称', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、保密范围：双方在合作中交换的商务、技术、价格等信息均属保密信息。\n二、有效期：{有效期}。\n三、违约责责：任一方违反保密义务应承担相应法律责任。',
  },
  {
    id: 5, name: '质量保证协议', category: '专项协议', signType: 1, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '无金额', enabled: false, updatedAt: '2026-06-30 11:00:00',
    variables: ['供应商名称', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、质量标准：乙方供货须符合国家标准及甲方验收规范。\n二、有效期：{有效期}。\n三、质量异议：甲方有权在收货后按约定时限提出质量异议。',
  },
  {
    id: 6, name: '物流服务协议', category: '专项协议', signType: 2, validityMonths: 12, paymentDays: 30, settleDay: 25,
    amountDesc: '按物流费用结算', enabled: true, updatedAt: '2026-07-18 15:40:00',
    variables: ['供应商名称', '配送范围', '有效期'],
    content: '甲方：安徽亿佳供应链集团有限公司\n乙方：{供应商名称}\n一、配送范围：{配送范围}。\n二、服务标准：乙方须保证时效与完好率。\n三、有效期：{有效期}。',
  },
]

/* ============ 合同管理（管理视角，完整生命周期，与用户侧规范对齐） ============ */
export const contracts = [
  {
    id: 1, contractNo: 'HT20260001', contractName: '兴业银行集采供应商合作框架协议', vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '兴业银行集采', type: '框架协议', signType: 2,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2026-01-01', endDate: '2026-12-31', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 1, templateName: '供应商合作框架协议（年度）',
    content: '年度框架合作协议，按实际订单月度结算，账期30天。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-frame.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht1-stamp.pdf',
    doubleStampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht1-double.pdf',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2025-12-20 10:00:00', initiatedAt: '2025-12-22 09:00:00',
    signedAt: '2026-01-05 10:00:00', esignProvider: '法大大', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '年度框架协议',
  },
  {
    id: 2, contractNo: 'HT20260002', contractName: '浦东发展银行办公用品采购合同', vendorId: 2, vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', type: '单笔合同', signType: 1,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2026-03-01', endDate: '2026-08-10', paymentDays: 60, settleDay: 20, amount: '389050.00',
    templateId: 2, templateName: '单笔采购合同',
    content: '单笔采购合同，账期60天。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-buy.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht2-stamp.pdf',
    doubleStampContractUrl: '',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-02-25 10:00:00', initiatedAt: '2026-02-26 09:00:00',
    signedAt: '2026-03-10 14:00:00', esignProvider: 'e签宝', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '',
  },
  {
    id: 3, contractNo: 'HT20260003', contractName: '联家商超供应链服务协议', vendorId: 4, vendorName: '得力集团有限公司',
    projectName: '联家', type: '框架协议', signType: 2,
    signStatus: '待对方签', contractStatus: '待签署',
    startDate: '2026-05-01', endDate: '2027-04-30', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 1, templateName: '供应商合作框架协议（年度）',
    content: '年度框架合作协议，待供应商用印。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-frame.pdf',
    stampContractUrl: '', doubleStampContractUrl: '', importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-04-20 10:00:00', initiatedAt: '2026-04-22 09:00:00',
    signedAt: '', esignProvider: '法大大', signTaskId: 'ES20260422001', signUrl: 'https://fadada.esign-demo.com/sign?task=ES20260422001',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '待供应商用印',
  },
  {
    id: 4, contractNo: 'HT20260004', contractName: '深圳齐心办公耗材供货合同', vendorId: 5, vendorName: '深圳齐心集团股份有限公司',
    projectName: '浦东发展银行', type: '单笔合同', signType: 1,
    signStatus: '已签署完成', contractStatus: '已到期',
    startDate: '2025-06-01', endDate: '2026-05-31', paymentDays: 30, settleDay: 25, amount: '125000.00',
    templateId: 2, templateName: '单笔采购合同',
    content: '单笔采购合同，已到期需续签。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-buy.pdf',
    stampContractUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht4-stamp.pdf',
    doubleStampContractUrl: '',
    importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2025-05-20 10:00:00', initiatedAt: '2025-05-22 09:00:00',
    signedAt: '2025-06-05 09:00:00', esignProvider: '法大大', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '2026-05-01 09:00:00', lastPaymentReminder: '',
    remark: '已到期，需续签',
  },
  {
    id: 5, contractNo: 'HT20250099', contractName: '历史纸质框架协议（补录）', vendorId: 1, vendorName: '江苏佳诺云电子科技有限公司',
    projectName: '中国建行集采云电商', type: '框架协议', signType: 2,
    signStatus: '已签署完成', contractStatus: '生效中',
    startDate: '2025-01-01', endDate: '2026-12-31', paymentDays: 30, settleDay: 25, amount: '按订单结算',
    templateId: 0, templateName: '线下纸质合同（补录）',
    content: '历史线下签署纸质合同，扫描件补录归档。',
    fileUrl: '', stampContractUrl: '', doubleStampContractUrl: '',
    importFile: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/ht5-history.pdf', isHistory: true,
    createdBy: '平台管理员', createdAt: '2026-07-20 10:00:00', initiatedAt: '', signedAt: '2025-01-10 09:00:00',
    esignProvider: '线下', signTaskId: '', signUrl: '',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '供应商线下已盖章，平台补录归档，纳入到期提醒',
  },
  {
    id: 6, contractNo: 'HT20260005', contractName: '兰维乐冷链物流服务协议', vendorId: 2, vendorName: '兰维乐（上海）食品有限公司',
    projectName: '浦东发展银行', type: '专项协议', signType: 2,
    signStatus: '签署中', contractStatus: '签署中',
    startDate: '2026-07-01', endDate: '2027-06-30', paymentDays: 30, settleDay: 25, amount: '按物流费用结算',
    templateId: 6, templateName: '物流服务协议',
    content: '冷链物流服务协议，已发起电子签署，等待双方意愿认证。',
    fileUrl: 'https://eabbc-prod.oss-cn-beijing.aliyuncs.com/images/tpl-logistics.pdf',
    stampContractUrl: '', doubleStampContractUrl: '', importFile: '', isHistory: false,
    createdBy: '平台管理员', createdAt: '2026-07-21 10:00:00', initiatedAt: '2026-07-22 09:00:00',
    signedAt: '', esignProvider: 'e签宝', signTaskId: 'ES20260722005', signUrl: 'https://esign.esign-demo.com/sign?task=ES20260722005',
    expireReminderDays: 30, paymentReminderDays: 7, lastExpireReminder: '', lastPaymentReminder: '',
    remark: '已发起电子签署，等待双方签署',
  },
]

/* ============ 供应商关停审批（管理视角，与用户侧 vendor/shutdown 对齐） ============ */
export const shutdowns = [
  { id: 1, vendorName: '深圳齐心集团股份有限公司', applyTime: '2026-07-22 09:30:00', shutdownTime: '2026-08-01 00:00:00', reason: '业务调整，暂停与平台的合作', status: '待审核', auditTime: '', auditReason: '' },
  { id: 2, vendorName: '上海晨光科力普办公用品有限公司', applyTime: '2026-07-18 15:00:00', shutdownTime: '2026-07-25 00:00:00', reason: '授权到期不再续签', status: '已驳回', auditTime: '2026-07-19 10:00:00', auditReason: '该供应商仍有在途订单，暂不可关停' },
  { id: 3, vendorName: '兰维乐（上海）食品有限公司', applyTime: '2026-06-30 11:00:00', shutdownTime: '2026-07-10 00:00:00', reason: '季节性调整', status: '已通过', auditTime: '2026-07-01 09:00:00', auditReason: '同意关停' },
]

/* ============ 发票管理（管理视角，与用户侧 finance/vendorInvoiceDownload + 对账单开票 对齐） ============ */
export const invoices = [
  { id: 1, invoiceNo: 'FP202607240001', shipId: 'S202607240001', purchaseOrderNo: 'PO202607200001', outOrderNo: 'C202607200001', vendorName: '江苏佳诺云电子科技有限公司', projectName: '兴业银行集采', invoiceAmount: '12580.00', invoiceType: '增值税专用发票', invoiceStatus: '待开票', invoiceTime: '', fileUrl: '', downloadStatus: '未下载' },
  { id: 2, invoiceNo: 'FP202607230002', shipId: 'S202607230002', purchaseOrderNo: 'PO202607180002', outOrderNo: 'C202607180002', vendorName: '兰维乐（上海）食品有限公司', projectName: '浦东发展银行', invoiceAmount: '3890.50', invoiceType: '增值税专用发票', invoiceStatus: '已开票', invoiceTime: '2026-07-24 09:00:00', fileUrl: '', downloadStatus: '已下载' },
  { id: 3, invoiceNo: 'FP202607220003', shipId: 'S202607220003', purchaseOrderNo: 'PO202607150003', outOrderNo: 'C202607150003', vendorName: '得力集团有限公司', projectName: '兴业银行集采', invoiceAmount: '25600.00', invoiceType: '增值税普通发票', invoiceStatus: '已作废', invoiceTime: '2026-07-22 16:00:00', fileUrl: '', downloadStatus: '未下载' },
]

/* ============ 售后服务管理（管理视角，与用户侧 aftersale/asManageApply 对齐） ============ */
export const aftersales = [
  { id: 1, serviceNo: 'AS202607240001', orderNo: 'PO202607200001', projectName: '兴业银行集采', type: '退货', applicant: '张主任', applicantMobile: '13800001111', applyTime: '2026-07-24 10:00:00', finishTime: '', skuName: '联想 ThinkPad X1 笔记本', skuId: 'SKU001', skuCode: 'LX-X1-001', unitPrice: '8999.00', quantity: 2, paidAmount: '17998.00', actualRefundAmount: '17998.00', reason: '客户验收不通过，申请退货', receiver: '张主任', receiverMobile: '13800001111', receiverAddress: '上海市浦东新区浦东南路XX号', status: '待处理' },
  { id: 2, serviceNo: 'AS202607230002', orderNo: 'PO202607180002', projectName: '浦东发展银行', type: '换货', applicant: '李主管', applicantMobile: '13800002222', applyTime: '2026-07-23 09:00:00', finishTime: '2026-07-24 14:00:00', skuName: '兰维乐 矿泉水 360ml*24瓶', skuId: 'SKU002', skuCode: 'LW-KS-002', unitPrice: '39.90', quantity: 10, paidAmount: '399.00', actualRefundAmount: '0.00', reason: '包装破损，申请换货', receiver: '李主管', receiverMobile: '13800002222', receiverAddress: '上海市徐汇区虹桥路XX号', status: '已完成' },
  { id: 3, serviceNo: 'AS202607220003', orderNo: 'PO202607150003', projectName: '兴业银行集采', type: '退货', applicant: '王经理', applicantMobile: '13800003333', applyTime: '2026-07-22 08:00:00', finishTime: '', skuName: '得力 A4 复印纸 70g', skuId: 'SKU003', skuCode: 'DL-PP-003', unitPrice: '25.00', quantity: 50, paidAmount: '1250.00', actualRefundAmount: '1250.00', reason: '非质量问题，客户原因退货', receiver: '王经理', receiverMobile: '13800003333', receiverAddress: '上海市浦东新区浦东南路XX号', status: '已拒绝' },
]

/* ============ 采购竞价管理（管理视角，与用户侧 bidding/purchaseBiddingManage 对齐） ============ */
export const biddings = [
  { id: 1, biddingNo: 'BJ202607240001', outBiddingNo: 'WB202607240001', goodsName: '联想 ThinkPad X1 笔记本', projectName: '兴业银行集采', goodsCount: 200, startPrice: '8999.00', deadline: '2026-07-28 18:00:00', openTime: '2026-07-25 09:00:00', image: '', address: '上海市浦东新区', status: '进行中', owner: '', quoteCount: 0, supplierCount: 0 },
  { id: 2, biddingNo: 'BJ202607230002', outBiddingNo: 'WB202607230002', goodsName: '得力 A4 复印纸 70g', projectName: '浦东发展银行', goodsCount: 5000, startPrice: '25.00', deadline: '2026-07-26 18:00:00', openTime: '2026-07-24 09:00:00', image: '', address: '上海市徐汇区', status: '进行中', owner: '运营-小李', quoteCount: 3, supplierCount: 2 },
  { id: 3, biddingNo: 'BJ202607200003', outBiddingNo: 'WB202607200003', goodsName: '兰维乐 矿泉水 360ml*24', projectName: '联家', goodsCount: 10000, startPrice: '39.90', deadline: '2026-07-22 18:00:00', openTime: '2026-07-21 09:00:00', image: '', address: '上海市浦东新区', status: '已结束', owner: '运营-小王', quoteCount: 8, supplierCount: 5 },
]

/* ============ 询价单管理（管理视角，与用户侧 bidding/inquirySheetManage 对齐） ============ */
export const inquiries = [
  { id: 1, inquiryNo: 'XJ202607240001', projectName: '浦发银行', inquiryType: '普通询价', itemCount: 36, deadline: '2026-07-28 18:00:00', feedbackTime: '2026-07-29 12:00:00', status: '待报价', assignedVendor: '', quoteCount: 0 },
  { id: 2, inquiryNo: 'XJ202607230002', projectName: '联家', inquiryType: '紧急询价', itemCount: 12, deadline: '2026-07-25 12:00:00', feedbackTime: '2026-07-25 18:00:00', status: '已报价', assignedVendor: '得力集团有限公司', quoteCount: 1 },
  { id: 3, inquiryNo: 'XJ202607200003', projectName: '京东', inquiryType: '普通询价', itemCount: 50, deadline: '2026-07-21 18:00:00', feedbackTime: '2026-07-22 12:00:00', status: '已截止', assignedVendor: '兰维乐（上海）食品有限公司', quoteCount: 2 },
]

/* ============ 消息中心（管理端接收各模块待办/告警/通知） ============ */
export const messages = [
  { id: 1, title: '商品审核待办', content: '兰维乐 矿泉水 360ml*24瓶 等待商品初审', type: '待办', module: '商品', relatedPath: '/product/audit', time: '2026-07-25 09:30:00', read: false },
  { id: 2, title: '报备订单待审核', content: '浦东发展银行 报备订单 RB202607240001 等待审核', type: '待办', module: '订单', relatedPath: '/order/report', time: '2026-07-25 09:10:00', read: false },
  { id: 3, title: '资质授权待审核', content: '江苏佳诺云电子科技有限公司 联想品牌授权 待审核', type: '待办', module: '供应商', relatedPath: '/vendor/qualification-audit', time: '2026-07-25 08:50:00', read: false },
  { id: 4, title: '供应商关停申请', content: '深圳齐心集团股份有限公司 申请关停，待平台审核', type: '告警', module: '供应商', relatedPath: '/vendor/shutdown-audit', time: '2026-07-24 18:00:00', read: false },
  { id: 5, title: '反采申请待审核', content: '兰维乐 反采申请 FC202607230001 等待审核', type: '待办', module: '订单', relatedPath: '/order/reverse', time: '2026-07-24 15:00:00', read: true },
]

/* ============ 管理端角色权限（平台运营/财务/客服等） ============ */
export const roles = [
  { id: 1, appName: '供应商管理后台', roleId: 'R1001', roleName: '平台管理员', description: '拥有全部管理权限', createTime: '2026-01-01 00:00:00', permissions: ['supplier', 'product', 'order', 'finance', 'bidding', 'aftersale', 'system'] },
  { id: 2, appName: '供应商管理后台', roleId: 'R1002', roleName: '运营专员', description: '商品/订单/竞价运营', createTime: '2026-03-01 00:00:00', permissions: ['product', 'order', 'bidding'] },
  { id: 3, appName: '供应商管理后台', roleId: 'R1003', roleName: '财务专员', description: '对账/发票/结算', createTime: '2026-03-01 00:00:00', permissions: ['finance'] },
  { id: 4, appName: '供应商管理后台', roleId: 'R1004', roleName: '客服专员', description: '售后/消息处理', createTime: '2026-03-01 00:00:00', permissions: ['aftersale', 'message'] },
]
